var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_520",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29231",
    "data-name": "Group 29231",
    transform: "translate(583 10673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -583, -10673)",
    filter: "url(#Ellipse_520)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_520-2",
    "data-name": "Ellipse 520",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50320",
    "data-name": "Path 50320",
    d: "M3141,2860.873h2.868V2858H3141Z",
    transform: "translate(-3689.011 -13500.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50321",
    "data-name": "Path 50321",
    d: "M2977.093,2695.5h-3.684a.406.406,0,0,1-.408-.4v-3.684a.411.411,0,0,1,.408-.408h3.684a.407.407,0,0,1,.4.408v3.684A.4.4,0,0,1,2977.093,2695.5Z",
    transform: "translate(-3521.828 -13334.593)",
    fill: "#df6b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50322",
    "data-name": "Path 50322",
    d: "M3818.679,2695.5H3815V2691h3.679a.411.411,0,0,1,.409.408v3.684A.406.406,0,0,1,3818.679,2695.5Z",
    transform: "translate(-4359.735 -13334.593)",
    fill: "#80b4fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50323",
    "data-name": "Path 50323",
    d: "M2977.093,1938.491h-3.684a.406.406,0,0,1-.408-.4V1934.4a.406.406,0,0,1,.408-.4h3.684a.4.4,0,0,1,.4.4v3.684A.4.4,0,0,1,2977.093,1938.491Z",
    transform: "translate(-3521.828 -12581.272)",
    fill: "#eab14d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50324",
    "data-name": "Path 50324",
    d: "M3818.679,1938.491H3815V1934h3.679a.407.407,0,0,1,.409.4v3.684A.407.407,0,0,1,3818.679,1938.491Z",
    transform: "translate(-4359.735 -12581.272)",
    fill: "#b3e59f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50325",
    "data-name": "Path 50325",
    d: "M2977.093,1180.5h-3.684a.411.411,0,0,1-.408-.408v-3.679a.411.411,0,0,1,.408-.408h3.684a.406.406,0,0,1,.4.408v3.679A.406.406,0,0,1,2977.093,1180.5Z",
    transform: "translate(-3521.828 -11826.957)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50326",
    "data-name": "Path 50326",
    d: "M3818.679,1180.5H3815V1176h3.679a.411.411,0,0,1,.409.408v3.679A.411.411,0,0,1,3818.679,1180.5Z",
    transform: "translate(-4359.735 -11826.957)",
    fill: "#df6b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50327",
    "data-name": "Path 50327",
    d: "M800.641,1303.87h-3.232a.407.407,0,0,1-.408-.4v-3.553a.917.917,0,0,1,.919-.914h2.212a.917.917,0,0,1,.919.914v3.553A.407.407,0,0,1,800.641,1303.87Z",
    transform: "translate(-1356.405 -11949.358)",
    fill: "#d62966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50328",
    "data-name": "Path 50328",
    d: "M323.331,2139.094H315.4a.407.407,0,0,1-.4-.408v-3.6a1.084,1.084,0,0,1,1.079-1.084h6.576a1.084,1.084,0,0,1,1.079,1.084v3.6A.407.407,0,0,1,323.331,2139.094Z",
    transform: "translate(-876.747 -12780.3)",
    fill: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50329",
    "data-name": "Path 50329",
    d: "M134.038,3022.934a.415.415,0,0,1-.311-.141,7.763,7.763,0,0,1-.564-.909l-4.447-6.785c-.4-.583-.073-1.1.462-1.1h9.313a1.571,1.571,0,0,1,1.128.627l1.079,1.487h13.624a.408.408,0,0,1,.394.506h4a.408.408,0,0,1,.394-.506h2.348a.4.4,0,0,1,.34.622l-3.247,5.142-.243.423a.405.405,0,0,1-.671.053l-11.383,1.546-11.816-1.283A.4.4,0,0,1,134.038,3022.934Z",
    transform: "translate(-691.192 -13656.023)",
    fill: "#d62966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50330",
    "data-name": "Path 50330",
    d: "M890.535,4346.812,890,4346h27.195l-.515.812Z",
    transform: "translate(-1448.953 -14981.549)",
    fill: "#c1255c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50331",
    "data-name": "Path 50331",
    d: "M25.266,4572.235c-2.464,0-3.373-1.229-5.643-1.229s-3.179,1.229-5.643,1.229-3.368-1.229-5.638-1.229-3.179,1.229-5.643,1.229a6.235,6.235,0,0,1-3.028-.671c-.19-.112-.156-.331-.141-.554.044-.788-.039-3.125,0-3.193a.4.4,0,0,1,.554-.146,5.509,5.509,0,0,0,2.615.56c2.275,0,3.179-1.23,5.643-1.23s3.368,1.23,5.638,1.23,3.179-1.23,5.643-1.23,3.368,1.23,5.638,1.23S28.44,4567,30.9,4567a6.291,6.291,0,0,1,3.028.67c.19.117.141.336.141.56v3.188c0,.229-.36.263-.554.146a5.509,5.509,0,0,0-2.615-.559C28.63,4571.005,27.731,4572.235,25.266,4572.235Z",
    transform: "translate(-562.799 -15201.475)",
    fill: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50332",
    "data-name": "Path 50332",
    d: "M1542.662,3773.042h-.642a1.021,1.021,0,0,1,0-2.042h.642a1.021,1.021,0,0,1,0,2.042Zm5.633,0h-.642a1.021,1.021,0,0,1,0-2.042h.642a1.021,1.021,0,0,1,0,2.042Zm5.633,0h-.637a1.021,1.021,0,0,1,0-2.042h.637a1.021,1.021,0,0,1,0,2.042Zm5.638,0h-.642a1.021,1.021,0,0,1,0-2.042h.642a1.021,1.021,0,0,1,0,2.042Z",
    transform: "translate(-2096.788 -14409.344)",
    fill: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50333",
    "data-name": "Path 50333",
    d: "M25.266,5184.229c-2.464,0-3.373-1.229-5.643-1.229s-3.179,1.229-5.643,1.229S10.612,5183,8.342,5183s-3.179,1.229-5.643,1.229a6.235,6.235,0,0,1-3.028-.67c-.19-.112-.156-.331-.141-.554.044-.788-.039-3.125,0-3.193a.4.4,0,0,1,.554-.146,5.509,5.509,0,0,0,2.615.56c2.275,0,3.179-1.225,5.643-1.225s3.368,1.225,5.638,1.225S17.159,5179,19.623,5179s3.368,1.225,5.638,1.225S28.44,5179,30.9,5179a6.241,6.241,0,0,1,3.028.67c.19.112.141.331.141.555v3.193c0,.223-.36.257-.554.141A5.509,5.509,0,0,0,30.9,5183C28.63,5183,27.731,5184.229,25.266,5184.229Z",
    transform: "translate(-562.799 -15810.5)",
    fill: "#d3effb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50334",
    "data-name": "Path 50334",
    d: "M4763.672,826.078a.416.416,0,0,1-.111-.019,8.292,8.292,0,0,1-3.933-2.576,6.456,6.456,0,0,1-1.628-4.1v-4.579a.385.385,0,0,1,.243-.365,19.562,19.562,0,0,0,5.157-3.086.4.4,0,0,1,.544,0,19.59,19.59,0,0,0,5.162,3.086.389.389,0,0,1,.238.365v4.579c0,3.033-2.659,5.847-5.556,6.674A.49.49,0,0,1,4763.672,826.078Z",
    transform: "translate(-5298.151 -11463.979)",
    fill: "#335f8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50335",
    "data-name": "Path 50335",
    d: "M5070.175,1235.258a.375.375,0,0,1-.126-.02c-2.12-.69-4.049-2.746-4.049-4.967v-3.407a.4.4,0,0,1,.233-.36,17.524,17.524,0,0,0,3.689-2.163.4.4,0,0,1,.505,0,17.5,17.5,0,0,0,3.684,2.163.392.392,0,0,1,.238.36v3.407c0,2.226-1.92,4.263-4.054,4.967A.335.335,0,0,1,5070.175,1235.258Z",
    transform: "translate(-5604.655 -11874.972)",
    fill: "#5684b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50336",
    "data-name": "Path 50336",
    d: "M5454.918,2040.813a.4.4,0,0,1-.38-.277l-.515-1.628a.4.4,0,0,1,.257-.5.407.407,0,0,1,.5.258l.341,1.084,2.926-2.323a.4.4,0,0,1,.5.622l-3.379,2.678A.393.393,0,0,1,5454.918,2040.813Z",
    transform: "translate(-5990.773 -12684.109)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.c1f6f8b3883d043d38bfec4217990569.svg";
export { ForwardRef as ReactComponent };